// LocalStorage helpers for onboarding auto-save. Keyed per step so a partial
// completion of Step 2 doesn't overwrite the campaign draft in Step 4.
//
// All catches are intentionally silent for the *user-facing* path (private
// browsing / quota-exceeded / disabled localStorage must not crash the app).
// devWarn surfaces the failure in DevTools during development so onboarding
// regressions don't slip through unnoticed; in production it is a no-op.
import { devWarn } from "./dev-log";

const NS = "bp_onb_";

export const loadDraft = (step) => {
  try {
    const raw = localStorage.getItem(NS + step);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    devWarn("[onboarding-storage] loadDraft failed", { step, err });
    return null;
  }
};

export const saveDraft = (step, data) => {
  try {
    localStorage.setItem(NS + step, JSON.stringify(data));
  } catch (err) {
    // Most commonly quota-exceeded in private browsing. Non-fatal.
    devWarn("[onboarding-storage] saveDraft failed", { step, err });
  }
};

export const clearDraft = (step) => {
  try {
    localStorage.removeItem(NS + step);
  } catch (err) {
    devWarn("[onboarding-storage] clearDraft failed", { step, err });
  }
};

export const clearAllDrafts = () => {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(NS))
      .forEach((k) => localStorage.removeItem(k));
  } catch (err) {
    devWarn("[onboarding-storage] clearAllDrafts failed", { err });
  }
};
